import store from "@/store/index";

export default {
  methods: {
    hasRoleAccess(roles = []) {
      return roles.some((role) => store.state.auth.roles.includes(role));
    },
  },
};
